import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import * as AOS from 'aos';
import { } from 'jquery';
declare let gtag: Function;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})

export class AppComponent {
  title = 'TriidyWeb';

  constructor(public router: Router) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        gtag('config', 'UA-151132014-1',
          {
            '/': event.urlAfterRedirects,
            '/somos-triidy': event.urlAfterRedirects,
            '/beneficios': event.urlAfterRedirects,
            '/ayuda': event.urlAfterRedirects,
            '/pedidos/rastreo': event.urlAfterRedirects,
            '/r': event.urlAfterRedirects,
            '/registrate': event.urlAfterRedirects,
            '/trabaja-con-nosotros': event.urlAfterRedirects,
            '/iniciar-sesion': event.urlAfterRedirects,
            '/terminos-condiciones': event.urlAfterRedirects,
            '/politicas-de-privacidad': event.urlAfterRedirects,
            // DASHBOARD
            '/dashboard': event.urlAfterRedirects,
            '/dashboard/marketplace': event.urlAfterRedirects,
            '/dashboard/ventas': event.urlAfterRedirects,
            '/dashboard/productos': event.urlAfterRedirects,
          }
        );
      }
    }
    )
  }

  ngOnInit(): void {
    jQuery(document).ready(function () {
      /*$('body').bind('cut copy paste', function (e) {
        e.preventDefault();
      });*/
      /*$("body").on("contextmenu", function (e) {
        return false;
      });*/
    });

    AOS.init();
  }
}
